// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R9IQ","index":"styles_index__2B22Z"};